import { Component, Input, OnInit } from '@angular/core';
import { Util } from 'services/util';

/**
 * See zeplin: https://zpl.io/aX3mYMX
 *
 * |_______________________|
 * 0                       10
 *  0 = lowPoint                    o to 10 = leftBar
 *  10 = midPoint OR highPoint
 *
 * |_________|______________________|__________|
 * 0         5                      8          9
 *  0 = lowPoint               0 to 5 = leftBar
 *  5 = midPoint               5 to 8 = overageBar
 *  8 = overagePoint           8 to 9 = rightBar
 *  9 = highPoint
 */

@Component({
    selector: 'overage-graph',
    styleUrls: ['./graph.scss'],
    templateUrl: './graph.html',
    standalone: false
})
export class OverageGraphComponent implements OnInit {
    @Input() public dataUsage: number; // in MB
    @Input() public overage: number; // in MB
    @Input() public dataPassSize: number; // in MB

    public leftBarStyle: object;
    public leftProgressStyle: object;

    public rightBarStyle: object;
    public rightProgressStyle: object;

    public overageBarStyle: object;
    public overageProgressStyle: object;

    public lowPoint: number;
    public midPoint: number;
    public highPoint: number;
    public overagePoint: number;
    public showMidPoint: boolean = true;

    public ngOnInit(): void {
        this.lowPoint = 0;
        this.overage = parseFloat(Util.mbToGb(this.overage, false)) || 0;

        // mid point should be minimum 1 in any case
        this.midPoint = parseFloat(Util.mbToGb(this.dataPassSize, false)) || 1;
        this.highPoint = Math.max(parseFloat(Util.mbToGb(this.dataUsage, true)), this.midPoint);
        this.dataUsage = parseFloat(Util.mbToGb(this.dataUsage, false));
        this.dataPassSize = parseFloat(Util.mbToGb(this.dataPassSize, false));

        if (!this.overage) {
            this.leftBarStyle = { width: '100%' };
            this.leftProgressStyle = { width: `${(this.dataUsage * 100) / this.dataPassSize }%` };
            this.rightBarStyle = { display: 'none' };
            this.overageBarStyle = { display: 'none' };
        } else {
            this.overagePoint = this.highPoint - 1;
            this.showMidPoint = this.overagePoint !== this.midPoint;
            const rightBarWidth: number = 100 / (this.highPoint - this.midPoint + 1);
            this.rightBarStyle = this.leftBarStyle = { width: `calc(${ rightBarWidth }% - 2px)` };
            this.overageBarStyle = { width: `calc(${(this.overagePoint - this.midPoint) * rightBarWidth}% - 4px)` };
            this.leftProgressStyle = this.overageProgressStyle = { width: '100%' };
            this.rightProgressStyle = { width: `${ (this.dataUsage - this.overagePoint) * 100 }%` };
        }
    }
}
